<template>
    <div class="w-full" ref="artRef"></div>
  </template>
  <script>
  import Artplayer from "artplayer";
  export default {
    name: 'player',
    data() {
      return {
        instance: null,
      };
    },
    props: {
      option: {
        type: Object,
        required: true,
      },
    },
    mounted() {
      this.instance = new Artplayer({
        ...this.option,
        container: this.$refs.artRef,
       
      });
      this.instance.on('ready', () => {
        const art = this.instance
        art.loading.show = false;
        art.controls.show = false;
        art.autoHeight = true
        });
      

      /* this.instance.on('video:loadeddata', () =>{
        const art = this.instance
        art.loading.show = true
      }) */
      
      this.$nextTick(() => {
        this.$emit("get-instance", this.instance);
      });
    },
    beforeUnmount() {
      if (this.instance && this.instance.destroy) {
        this.instance.destroy(false);
      }
    },
  };
  </script>